import React from 'react'
import './RestartChat.css';
import apiService from '../../Services/apiServices';

const RestartChat = (props) => {
    const {clearMessages, setShowMsgs ,showMaximumChat ,startLogin ,setCheckThumsDownFeedback} =props
  return (
    <div
    className="restart-chat-container"
    style={{
        display: "flex",
        height: "2rem",
        marginTop:'12px',
        marginBottom: "10px",
        width: showMaximumChat ? "87%" : "92%",
        cursor: "pointer"
    }}
>
    <button
        onClick={() => {
            clearMessages()
            apiService.loginForRefresh('6')
            startLogin()
            setShowMsgs(false)
            setCheckThumsDownFeedback([])
        }}
        style={{
            background: "#D02F92",
            border: "1px solid white",
            borderRadius: "5px",
            color: "white",
            width: "6rem",
            fontSize: "small",
            cursor: 'pointer',
            marginLeft:'36px'
        }}
    >
        Restart Chat
    </button>
</div>
  )
}

export default RestartChat
